import axios from "../../../../../axios";
import Cookies from "js-cookie";

export const GetAssessmentCandidates = async () => {
  const token = Cookies.get("employeeToken");

  return axios.post("/api/Candidate/GetAssessmentCandidates", {
    token,
  });
};
